/**
 * Features that are switched off for now — hidden, not removed.
 *
 * Coquis holds no stock. An order comes in, they place it with the supplier and
 * the supplier delivers, so a count of units on a shelf describes nothing real.
 * Everything that shows or edits stock levels is therefore hidden: the Inventory
 * page, the restock list, the stock column in reports, the grid on the product
 * editor. The pages, the inventory tables and every figure already recorded are
 * left exactly as they are.
 *
 * Bringing it back takes two steps, and both are needed:
 *
 *   1. set SHOW_STOCK to true here, rebuild and redeploy the panel;
 *   2. run the "to unhide" block at the foot of
 *      supabase/migrations/20260923120020_stock_tracking_off.sql, which puts
 *      products.track_inventory back exactly as it was.
 *
 * Step 1 only puts the controls back on screen. Step 2 is what makes the shop
 * obey stock levels again — until it runs, a size can never sell out. Count the
 * stock before running it: the quantities still in the table are as old as the
 * day this was switched off, and the shop will start believing them again the
 * moment it does.
 */
export const SHOW_STOCK = false

/**
 * Invoicing is a work in progress.
 *
 * It saves, numbers and prints, but it has not been through a full round of use
 * against real documents yet, so every screen that makes or lists one carries a
 * notice saying so. Set to false when the shop is happy with it and the notice
 * disappears everywhere at once (components/Notices.jsx).
 */
export const INVOICING_IS_PREVIEW = true

/**
 * The trading figures in this database are demonstration data.
 *
 * The catalogue is real, but the orders, revenue and visitor numbers were seeded
 * so the dashboard and reports had something to show while the system was being
 * built. Until the shop is taking live orders, every screen that is nothing but
 * figures says where they came from: a sample revenue figure read as a real one
 * is the most expensive mistake this panel could cause. Set to false on the day
 * the shop goes live and the seeded orders are cleared out.
 */
export const FIGURES_ARE_SAMPLE_DATA = true
